var map = {
	"./1.png": "775a",
	"./2.jpg": "cedd",
	"./2.png": "8e30",
	"./3.jpg": "a760",
	"./4.jpg": "ab86",
	"./5.jpg": "4e68",
	"./6.jpg": "7220",
	"./7.jpg": "de17",
	"./8.png": "eadf"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "bb6e";